// extracted by mini-css-extract-plugin
export var body = "_l9-8";
export var button = "_l9-0";
export var closeButton = "_l9-5";
export var content = "_l9-3";
export var empty = "_l9-f";
export var grid = "_l9-c";
export var header = "_l9-4";
export var icon = "_l9-1";
export var option = "_l9-d";
export var optionSelected = "_l9-e";
export var overlay = "_l9-2";
export var searchIcon = "_l9-a";
export var searchInput = "_l9-b";
export var searchWrapper = "_l9-9";
export var title = "_l9-6";
export var visuallyHidden = "_l9-7";